import React, { useState, useEffect } from 'react';
// import Layout from '@/common/Layout';
import { Form, Card, Space, Input } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import { getAllMasterProducts } from '../../redux/slice';
import useServerPagination from '@/hooks/useServerPagination';
import CustomTable from 'common/Content/CustomTable';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import Layout from '@/common/Layout';
import { useDispatch } from 'react-redux';
import { getLoggedInUser } from 'utilities/helpers';

const { Search } = Input;

const ProductsMasterList = ({ loading }) => {
  const [form] = Form.useForm();
  const { user } = getLoggedInUser();
  // const { SuperadminProddata } = getRoles('Production');
  //   const { allSamples } = useSelector((state) => state.stocks);
  const [allsuppliers, setAllsuppliers] = useState([]);
  const { page, pageSize, onChange, reset } = useServerPagination();
  const [pagination, setPagination] = useState({});
  const [search, setSearch] = useState('');
  //   console.log(allsamples);
  const dispatch = useDispatch();
  useEffect(() => {
    handleGetAllProducts();
  }, [page, pageSize, search]);

  const handleGetAllProducts = () => {
    const payload = { page: page, per_page: pageSize, search: search };
    dispatch(getAllMasterProducts(payload)).then((response) => {
      if (response?.payload?.success) {
        setAllsuppliers(response?.payload?.data);
        setPagination(response?.payload?.pagination);
      }
    });
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
    reset();
  };

  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'product_name',
      key: 'product_name',
      ellipsis: true,
      width: '100px',
      render: (text, record) => {
        return <a href={`/master-product-view/${record.id}`}>{text}</a>;
      }
    },
    {
      title: 'Product Short Name',
      dataIndex: 'product_name_type',
      key: 'product_name_type',
      ellipsis: true,
      width: '100px'
    },
    {
      title: 'ShelfLife',
      dataIndex: 'shelf_life',
      key: 'shelf_life',
      ellipsis: true,
      width: '100px'
    },
    {
      title: 'Sub Product Type',
      dataIndex: 'sub_product_type',
      key: 'sub_product_type',
      ellipsis: true,
      width: '100px'
    }
  ];

  return (
    <>
      <Layout sider={false}>
        <Form form={form} layout="vertical">
          <Card
            title={<span>Product Details</span>}
            className={`${styles.cardStyles_approver}`}
            extra={
              <Space>
                {user?.role == 'prod_user' || user?.role == 'qa_super_user' ? (
                  <CustomButton
                    className={styles.inwardButton}
                    // onClick={() => history.push('/create-product')}
                    onClick={() => history.push('/product-masters-create')}
                    type="primary"
                  >
                    Create
                  </CustomButton>
                ) : (
                  ''
                )}
                <Search
                  onChange={(e) => handleChange(e)}
                  className={`w-100 ${styles.searchbar}`}
                  justify="start"
                  align="start"
                  placeholder="Search by Product Name"
                />
              </Space>
            }
          >
            <div className={`${styles.table_container}`}>
              <CustomTable
                columns={columns}
                showPaginationMeta
                pagination={{
                  size: 'small',
                  total: pagination?.total_records || 0,
                  current: page,
                  pageSize,
                  onChange
                }}
                dataSource={allsuppliers}
                loading={loading}
              />
            </div>
          </Card>
          <br />
          <FormItem className="text-center">
            <CustomButton
              className={styles.inwardButton}
              onClick={() => history.push('/dashboard')}
              type="primary"
            >
              Back to Home
            </CustomButton>
          </FormItem>
        </Form>
      </Layout>
    </>
  );
};
export default ProductsMasterList;
